<template>
  <f7-page no-swipeback>
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-md="material:menu" panel-open="left"/>
      </f7-nav-left>
      <f7-nav-title>{{$tc('label.budget', 2)}}</f7-nav-title>
      <f7-nav-right v-if="isAdmin">
        <f7-link :href="links.budget" icon-only icon-ios="f7:plus" icon-md="material:add"
                 :class="{disabled: !hasMasterPot}"/>
      </f7-nav-right>
    </f7-navbar>
    <f7-block v-if="!hasMasterPot && isLoaded" class="welcome">
      <h1>{{$t('title.welcome')}}</h1>
      <p>{{$t('text.verifying')[0]}}</p>
      <p>{{$t('text.verifying')[1]}}</p>
    </f7-block>
    <f7-card v-for="budget in activeManagedBudgets" :key="budget.potId" class="budget-card" :class="{'master': isMaster(budget)}">
      <f7-card-header>{{budget.name}}<span v-if="isMaster(budget)">MASTER</span></f7-card-header>
      <f7-card-content>
        <f7-icon f7="chart_pie_fill"/>
        <span class="amount">{{formatMoney(budget.currency, budget.balance)}}</span>
      </f7-card-content>
      <f7-card-footer>
        <f7-link @click="showBudgetOptions(budget)">{{$t('action.manage')}}</f7-link>
        <f7-link :href="`${links.manageRequests}/${budget.potId}`" :text="$t('action.requests')+' '"
                 :badge="budget.pendingRequests" badge-color="pink" popover-close/>
        <f7-link @click="showFundOptions(budget)">{{$t('action.funds')}}</f7-link>
      </f7-card-footer>
    </f7-card>
    <f7-block v-if="isAdmin && inactiveBudgets.length > 0" class="text-align-center">
      <f7-link @click="showInactive = !showInactive">{{showInactive ? $t('action.hideInactiveBudgets') :
        $t('action.showInactiveBudgets') }}
      </f7-link>
    </f7-block>
    <f7-card v-if="showInactive" v-for="budget in inactiveBudgets" :key="budget.potId" class="budget-card">
      <f7-card-header>{{budget.name}}</f7-card-header>
      <f7-card-content>
        <f7-icon f7="pie"/>
        <span class="amount">{{formatMoney(budget.currency, budget.balance)}}</span>
      </f7-card-content>
      <f7-card-footer>
        <f7-link :href="`${links.manageRequests}/${budget.potId}`" :text="$t('action.viewRequests')"/>
        <f7-link :href="`${links.report}/${budget.potId}`" :text="$t('action.report')"/>
      </f7-card-footer>
    </f7-card>
    <f7-actions ref="budgetOptions" convertToPopover>
      <f7-actions-group>
        <f7-actions-label>{{$t('title.manageBudget', {budget: selectedBudget.name})}}</f7-actions-label>
        <f7-actions-button @click="$f7router.navigate(`/budget/${selectedBudget.potId}`)">{{$t('action.settings')}}</f7-actions-button>
        <f7-actions-button @click="$f7router.navigate(`${links.report}/${selectedBudget.potId}`)">
          {{isMaster(selectedBudget) ? $t('action.companyReports') : $t('action.report')}}
        </f7-actions-button>
      </f7-actions-group>
    </f7-actions>
    <f7-actions ref="fundOptions" convertToPopover>
      <f7-actions-group>
        <f7-actions-label>{{selectedBudget.name}}</f7-actions-label>
        <f7-actions-button @click="$f7router.navigate(`${links.topUpCard}/${selectedBudget.potId}`)">
          {{$t('action.topUpCard')}}
        </f7-actions-button>
        <f7-actions-button v-if="activeManagedBudgets.length > 1" @click="$f7router.navigate(`${links.budgetTransfer}/0/${selectedBudget.potId}`)">
          {{$t('action.transferToBudget')}}
        </f7-actions-button>
        <f7-actions-button v-if="activeManagedBudgets.length > 1" @click="$f7router.navigate(`${links.budgetTransfer}/${selectedBudget.potId}`)">
          {{$t('action.transferFromBudget')}}
        </f7-actions-button>
      </f7-actions-group>
    </f7-actions>
    <main-toolbar slot="fixed" :active="0"/>
  </f7-page>
</template>

<script>
  import helpers from '@/utils/helpers'
  import MainToolbar from '../components/main-toolbar'

  export default {
    name: 'budgets-page',
    components: {
      MainToolbar
    },
    computed: {
      hasMasterPot () {
        return this.budgets.length > 0
      }
    },
    async created () {
      await this.$store.dispatch('budgets/fetch')
      this.isLoaded = true
    },
    data: () => ({
      isLoaded: false,
      selectedBudget: {
        name: ''
      },
      showInactive: false
    }),
    filters: {
      toUrl: budget => `/budget/${budget.potId}`
    },
    methods: {
      isMaster (budget) {
        return !budget.parentId
      },
      showBudgetOptions (budget) {
        this.selectedBudget = budget
        this.$refs.budgetOptions.open()
      },
      showFundOptions (budget) {
        this.selectedBudget = budget
        this.$refs.fundOptions.open()
      },
      toRequestLinkTitle (budget) {
        return budget.pendingRequests > 0 ? this.$t('action.pendingRequests') : this.$t('action.requests')
      }
    },
    mixins: [helpers]
  }
</script>

<style lang="scss" scoped>
  @import '@/sass/variables.scss';

  .welcome {
    animation: fadein 1s ease-in;
  }

  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  .budget-card {
    background: $background;
    &.master {
      background: $clean;
    }
    .card-header span {
      color: $white;
      background: $charcoal;
      border: 1px solid $charcoal;
      border-radius: 3px;
      font-weight: bold;
      font-size: 10px;
      padding: 2px 4px;
    }
    i {
      color: $med-grey;
      font-size: 20px;
    }
    .amount {
      color: $med-grey;
      float: right;
      font-size: 24px;
    }
  }
</style>
